// TODO: Sync with Rowan for specific values for each property
import { ThemeProvider } from "@rmwc/theme";
import * as React from "react";
import { defaultTheme as theme } from "./themes";

interface Props {
  options?: {
    [key: string]: string;
  };
  style?: {
    [key: string]: string;
  };
  wrap?: boolean;
}

export const MaterialThemeProvider: React.FC<Props> = props => {
  const { color } = theme.material;

  const kaggleDefaults = {
    primary: color.brand.blue[500],
    error: color.status.error[500],
    background: color.brand.grey[50],
    surface: color.white,
    primaryBg: color.brand.blue[500],
    secondaryBg: color.brand.grey[500],
    onPrimary: color.white,
  };

  const options = { ...kaggleDefaults, ...props.options };

  return (
    <ThemeProvider options={options} wrap={props.wrap} style={props.style}>
      {props.children}
    </ThemeProvider>
  );
};
